import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {ExgApplicationEventEmitter} from '../../../misc/classes/ExgApplicationEventEmitter';
import {ExcRestService} from 'exc-rest-v2';
import {ExcTranslation} from 'exc-core-v2';

@Component({
  selector: 'app-sv-oe-dasboard',
  templateUrl: './sv-oe-dasboard.component.html',
  styles: []
})
export class SvOeDasboardComponent extends ExcTranslation implements OnInit, AfterViewInit {

  [key: string]: any;

  private _data: any;

  @Input()
  set data(value: any) {
    this._data = value;
    this.loadData();

  }

  get data(): any {
    return this._data;
  }

  Events: ExgApplicationEventEmitter = new ExgApplicationEventEmitter();

  db: any = {
    title: 'User Dashboard'
    , version: 'Zuletzt aktualisiert am 25.07.2022'
    , titleWidgets: []
    , sections: [
      {
        caption: '', columns: 1, widgets:
          [{
            title: 'Bonus / Malus', description: '', widget: 'ExgDbListSumComponent', data: [
              {name: 'Einsatzbereitschaft', value: -2, unit: 'Punkte'}
              , {name: 'Bearbeitungsqualität', value: -1, unit: 'Punkte'}
              , {name: 'Fristen-/SLA-Einhaltung', value: -2, unit: 'Punkte'}
              , {name: 'Berichtsqualität', value: -1, unit: 'Punkte'}
            ]
          }]
      },
      {
        caption: '', columns: 4, widgets: [
          {
            title: 'Gesamt',
            description: 'letzte Bewertung von -2 bis 2',
            widget: 'ExgDbIconicComponent',
            data: {name: 'fad fa-star', value: -1, unit: 'Punkte', currency: false}
          },
          {
            title: 'Gesamt',
            description: 'letzte 3 Monate von -6 bis 6',
            widget: 'ExgDbIconicComponent',
            data: {name: 'fad fa-star', value: -5, unit: 'Punkte', currency: false}
          }/*,
          {
            widget: 'ExgDbIconicComponent',
            data: {name: 'fad fa-money-bill-wave', value: 80, unit: '%'},
            title: 'Basishonorar',
            description: 'prozentual'
          },
          {
            widget: 'ExgDbIconicComponent',
            data: {name: 'fad fa-money-bill-wave', value: 3.2, unit: '%'},
            title: 'Jahresbonus',
            description: 'prozentual'
          }*/
        ]
      }
    ]
    , noData: false
  };

  constructor(private excRest: ExcRestService) {
    super();
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {

  }

  loadData(): void {
    this.clearDashboard();
    if (this._data && this._data.oeID) {
      this.excRest.get(
        this.excRest.computeUrl('OEBenutzerDashboardR_Summary'
        , {oeID: this._data.oeID})
      ).subscribe((response: any) => {
        if (response.success) {
          this.createDashboard(response.data.Dashboard);
        } else {
          this.clearDashboard();
        }
      });
    }
  }

  createDashboard(dbList: any): void {
    let widgets1 = [];
    let widget1Values = [];
    let widgets2 = [];
    let BonusMalusReportQuality  = dbList.find((e: any) => e.kv_kidID.toLowerCase() == '5e85039a-7240-4814-a571-0fb24fa37fa1');
    let BonusMalusProcessingQuality  = dbList.find((e: any) => e.kv_kidID.toLowerCase() == 'be7784ba-ca45-419a-8d9c-607f8473e3c6');
    let BonusMalusOperationalReadiness  = dbList.find((e: any) => e.kv_kidID.toLowerCase() == '6056ba94-179f-4986-988d-b782bea99a1c');
    let BonusMalusSLAObservance  = dbList.find((e: any) => e.kv_kidID.toLowerCase() == '2f803da1-b7e9-488a-90f4-cbb3ec24bf6e');
    let BonusMalusLast3Month  = dbList.find((e: any) => e.kv_kidID.toLowerCase() == '15e3b2ba-4c87-4312-9dce-74dbc04aaffe');
    let BonusMalusLastScore  = dbList.find((e: any) => e.kv_kidID.toLowerCase() == '15e3b2ba-4c87-4312-9dce-74dbc04aafff');
    let BonusMalusBaseHonorar  = dbList.find((e: any) => e.kv_kidID.toLowerCase() == '15e3b2ba-4c87-4312-9dce-74dbc04aaffc');
    let BonusMalusBonus  = dbList.find((e: any) => e.kv_kidID.toLowerCase() == '15e3b2ba-4c87-4312-9dce-74dbc04aaffb');

    widget1Values.push(
      {name: BonusMalusReportQuality.kidCaption, value: BonusMalusReportQuality.kvValue, unit: BonusMalusReportQuality.kidUnit});
    widget1Values.push(
      {
        name: BonusMalusOperationalReadiness.kidCaption,
        value: BonusMalusOperationalReadiness.kvValue, unit: BonusMalusOperationalReadiness.kidUnit});
    widget1Values.push(
      {
        name: BonusMalusProcessingQuality.kidCaption,
        value: BonusMalusProcessingQuality.kvValue, unit: BonusMalusProcessingQuality.kidUnit});
    widget1Values.push(
      {name: BonusMalusSLAObservance.kidCaption, value: BonusMalusSLAObservance.kvValue, unit: BonusMalusSLAObservance.kidUnit});


    widgets1.push({
      title: 'Bonus / Malus', description: '', widget: 'ExgDbListSumComponent', data: widget1Values
    });
    if (BonusMalusLastScore) {
      widgets2.push({
        title: BonusMalusLastScore.kidCaption,
        description: BonusMalusLastScore.kidDescription,
        widget: 'ExgDbIconicComponent',
        data: {name: 'fad fa-star', value: BonusMalusLastScore.kvValue, unit: BonusMalusLastScore.kidUnit, currency: false}
      });
    }
    if (BonusMalusLast3Month) {
      widgets2.push({
        title: BonusMalusLast3Month.kidCaption,
        description: BonusMalusLast3Month.kidDescription,
        widget: 'ExgDbIconicComponent',
        data: {name: 'fad fa-star', value: BonusMalusLast3Month.kvValue, unit: BonusMalusLast3Month.kidUnit, currency: false}
      });
    }
    if (BonusMalusBaseHonorar) {
      widgets2.push({
        title: BonusMalusBaseHonorar.kidCaption,
        description: BonusMalusBaseHonorar.kidDescription,
        widget: 'ExgDbIconicComponent',
        data: {name: 'fad fa-money-bill-wave', value: BonusMalusBaseHonorar.kvValue, unit: BonusMalusBaseHonorar.kidUnit, currency: false}
      });
    }
    if (BonusMalusBonus) {
      widgets2.push({
        title: BonusMalusBonus.kidCaption,
        description: BonusMalusBonus.kidDescription,
        widget: 'ExgDbIconicComponent',
        data: {name: 'fad fa-money-bill-wave', value: BonusMalusBonus.kvValue, unit: BonusMalusBonus.kidUnit, currency: false}
      });
    }
    this.db.sections[0].widgets = widgets1;
    this.db.sections[1].widgets = widgets2;
    this.db.noData = false;
  }

  clearDashboard(): void {
    this.db.noData = true;
    this.db.sections[0].widgets = [];
    this.db.sections[1].widgets = [];
  }

}
